import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#F2F8F7',
      100: '#D9ECE8',
      200: '#B8DDD6',
      300: '#8ECABF',
      400: '#62B7AA',
      500: '#2B9D8F',
      600: '#1E7E73',
      700: '#155F57',
      800: '#103F3A',
      900: '#0A2623',
    },
    accent: {
      500: '#F37A3E',
      600: '#D9622B',
    },
    // Public-catalog dark palette (homepage + Songs/Artists/SongDetail/Search).
    // Logged-in pages keep the light theme via the global body bg below.
    night: {
      900: '#0B1830',
      800: '#0F1F3D',
      700: '#15294E',
      600: '#1B3461',
      500: '#23427B',
      400: '#3D5B97',
      300: '#7388B5',
      200: '#A8B7D2',
      100: '#D5DDEC',
      50: '#EEF1F8',
    },
  },
  fonts: {
    heading: "'Poppins', sans-serif",
    body: "'Nunito', sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: '#FCFFFE',
        color: '#0D1F1C',
      },
      a: {
        color: 'brand.700',
        _hover: { textDecoration: 'none' },
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: '12px',
        fontWeight: 700,
      },
      variants: {
        solid: {
          bg: 'accent.500',
          color: 'white',
          _hover: { bg: 'accent.600' },
        },
        outline: {
          borderColor: 'brand.500',
          color: 'brand.700',
          _hover: { bg: 'brand.50' },
        },
      },
    },
  },
});

export default theme;
